import axios from "../instance";

export default {
  addUser: (body) => {
    return axios.api
      .post("/users/createAdmin", body)
      .then((response) => response.data);
  },
};
